<!-- 用于企业和居民的分页 -->
<template>
    <div class='page box'>
        <div>共{{total}}条</div>
        <div :class="{notallow : current==1}" class="default" @click="changePage(0)">
           <Icon type="ios-arrow-back" />
            上一页
        </div>
        <div>{{current}} / {{lastPage}}</div>
        <div :class="{notallow : current==lastPage}" class="default" @click="changePage(1)">
            下一页
            <Icon type="ios-arrow-forward" />
        </div>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
    name:'scrollPage',
    //import引入的组件需要注入到对象中才能使用
    components: {},
    props:{
        total:{
            type:Number,
            default:0,
        },
        current:{
            type:Number,
            default:0,
        },
        pagesize:{
            type:Number,
            default:10,
        }
    },
    data() {
    //这里存放数据
        return {
            lastPage:0
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
       total(newVal){
          this.lastPage = Math.ceil(newVal/this.pagesize)
       }
    },
    //方法集合
    methods: {
        changePage(type){
            if((type==1 && this.current==this.lastPage) || (type==0 && this.current == 1)) return
            this.$emit('on-change',type)
        }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.page{
    color:#666;
    font-size: 14px
}
.default{
    margin:0 20px;
    cursor: pointer;
}
.default:hover{
    color:#ff7b44
}
.notallow{
    color:#999;
    cursor: not-allowed !important;
}
.notallow:hover{
    color:#999 !important;
}
</style>